import { render, staticRenderFns } from "./DiscountCoupon.vue?vue&type=template&id=230e5f9e&"
import script from "./DiscountCoupon.vue?vue&type=script&lang=js&"
export * from "./DiscountCoupon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports